var map = {
	"./MBTI.png": 90278,
	"./add.png": 2177,
	"./add_znt.png": 56336,
	"./ckt.png": 62702,
	"./dp.png": 35014,
	"./draw.png": 91464,
	"./fy.png": 13933,
	"./hy.png": 86979,
	"./jt.png": 66588,
	"./lj.png": 28676,
	"./ls.png": 91013,
	"./music.png": 9241,
	"./new.png": 62962,
	"./new_a.png": 2550,
	"./ppt.png": 86404,
	"./sc.png": 3648,
	"./sj.png": 86929,
	"./tscy.png": 43337,
	"./wy.png": 57366,
	"./xz.png": 57016,
	"./yd.png": 44761,
	"./yl.png": 30561,
	"./znt.png": 15152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16400;